<template>
    <div style="display: flex; align-items: center;">
        <div>
            <button @click="add" type="button" class="button">
                <i v-show="!adding" class="icon ion-android-cart"></i>
                <i v-show="adding" class="fa fa-spinner fa-spin"></i>
                Añadir al carrito
            </button>
        </div>
        <p class="qnt-wrap prod-li-qnt">
            <a @click.prevent="up" href="#" style="text-align:center; display:block;">
                <i class="fa fa-caret-up" ></i>
            </a>
            <input type="text" v-model="qty">
            <a @click.prevent="down" href="#" style="text-align:center; display:block;">
                <i class="fa fa-caret-down" ></i>
            </a>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        product: Object,
    },

    data() {
        return {
            qty: 1,
            adding: false,
        };
    },

    methods: {
        add() {
            this.adding = true;
            this.$inertia.post(`/cart`, {
                product_id: this.product.id,
                qty: this.qty,
            },
            {
                preserveState: false,
                preserveScroll: true,
            })
            .then(response => {
                // INIT_PRODUCTS_SLIDES();
            });
        },
        up() {
            this.qty++;
        },

        down() {
            if (this.qty > 1) {
                this.qty--;
            }
        },
    }
}
</script>

<style>

</style>
